// Core Modules
import { InjectionToken } from '@angular/core';

/**
 * Injection token for the browser Window object.
 * Use this token to inject the Window object in a type-safe manner.
 *
 * @example
 * ```typescript
 * private readonly window = inject(WINDOW);
 * ```
 */
export const WINDOW = new InjectionToken<Window>('Window');
